import produce from 'immer';

const INITIAL_STATE = {
  personData: null,
  updateData: null,
}

export default function person(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch(action.type) {
      case '@auth/SIGN_IN_SUCCESS': {
        draft.personData = action.payload;
        break;
      }

      case '@person/UPDATE_PERSON_SUCCESS': {
        draft.updateData = action.payload.person;
        break;
      }

      default:
    }
  });
}